import type { TFunction } from "i18next"

const TRANSFER_ROLE_KEYS: Record<string, { from: string; to: string }> = {
  WAREHOUSE_TO_CARRIER:   { from: "custody.role.warehouseLoader",  to: "custody.role.deliveryStaff" },
  CARRIER_TO_CUSTOMER:    { from: "custody.role.deliveryStaff",    to: "custody.role.receiver" },
  CARRIER_TO_WAREHOUSE:   { from: "custody.role.deliveryStaff",    to: "custody.role.warehouseLoader" },
  DRIVER_TO_CASHIER:      { from: "custody.role.driver",           to: "custody.role.cashier" },
  WAREHOUSE_TO_WAREHOUSE: { from: "custody.role.warehouseLoader",  to: "custody.role.receiverKeeper" },
  EXTERNAL_TO_CARRIER:    { from: "custody.role.externalSupplier", to: "custody.role.deliveryStaff" },
  BUYER_TO_CARRIER:       { from: "custody.role.customer",         to: "custody.role.deliveryStaff" },
}

export function transferRoles(type: string | null | undefined, t: TFunction): { from: string; to: string } {
  const keys = type && TRANSFER_ROLE_KEYS[type]
  if (keys) return { from: t(keys.from), to: t(keys.to) }
  return { from: t("custody.role.sender"), to: t("custody.role.receiverGeneric") }
}
